<template>
  <div class="details_page_wrap" :style="'height:'+wrapHeight+'px'" ref="detailsWrap">
    <div class="details_page_title">
      <h2>《{{$route.query.paperName}}》完成情况</h2>
      <!-- <el-button @click="back">返回</el-button> -->
    </div>
    <div class="details_page_top">
      <ul>
        <li>
          <img src="../../../../../../static/images/study/testImg/detailsPage/tijiaorenshu.png" alt="">
          <div>
            <h3>{{submitSum}}人</h3>
            <p>已提交人数（共{{totalSum}}人）</p>
          </div>
        </li>
        <li>
          <img src="../../../../../../static/images/study/testImg/detailsPage/pingjunfen.png" alt="">
          <div>
            <h3>{{averScore}}分</h3>
            <p>班级平均分</p>
          </div>
        </li>
        <li>
          <img src="../../../../../../static/images/study/testImg/detailsPage/zuigaofen.png" alt="">
          <div>
            <h3>{{maxScore}}分</h3>
            <p>班级最高分</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="details_page_bottom">
      <div class="details_page_bottom_title">
        <ul>
          <li
            :class="{active : i===curIdx}"
            v-for="(item, i) in tabList" :key="i"
            @click="tabSwitch(i)"><p>{{item}}</p></li>
        </ul>
        <div class="details_page_bottom_search" v-if="curIdx==0">
          <el-button plain @click="exportList()" style="margin-right: 10px;">导出</el-button>
          <el-input
            v-model="studentName"
            prefix-icon="el-icon-search"
            @keyup.enter.native="searchStudengName(studentName)"
            @blur="searchStudengName(studentName)"
            placeholder="请输入学生姓名或学号"
            clearable></el-input>
          <el-button plain @click="search()">查询</el-button>
          <el-button plain @click="batchRecall(userIdsList)">交卷撤回</el-button>
          <el-button plain @click="batchRecallSubmissionPapers(userIdsList)">强制交卷</el-button>
        </div>
      </div>
      <div class="student_details_content" v-if="curIdx==0" v-loading="loadingx">
        <el-table
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :height="wrapHeight-280"
          row-key="userId"
          :header-cell-style="headerCellStyle"
          @sort-change='sortthiscolumn'
          class="student_details_table"
          :default-sort="{prop: 'score', order: 'descending'}"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div class="empty_data">
              <img src="../../../../../../static/images/wujieguo.png"/>
              <p>暂无数据</p>
            </div>
          </template>

          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="studentNo" label="学号"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span>{{ scope.row.status==0 ? '未提交' : '已提交'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="得分" sortable='custom' :sort-orders="['ascending', 'descending']">
            <template slot-scope="scope">
              <template v-if="$route.query.markingWay == 1 && scope.row.status == 1">
                {{ `批阅得分${ scope.row.subjectiveScore || 0 }、机器评分${ scope.row.objectiveScore || 0 }、总得分${
                scope.row.score || 0 }` }}
              </template>
              <template v-else>
                <span v-if="scope.row.score">{{scope.row.score}}</span>
                <span v-else-if="scope.row.score==0">0</span>
                <span v-else>--</span>
              </template>

            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="240">
            <template slot-scope="scope">
              <el-button v-if="noDemo" @click.native.prevent="seeRow(scope.row)" round size="small">查看</el-button>
              <el-button v-if="scope.row.status == 1" @click.native.prevent="withdrawExam(scope.row)" round
                         size="small">撤回
              </el-button>
              <el-button v-else @click.native.prevent="submissionPapers(scope.row)" round
                         size="small">强制交卷
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="details_page_content" v-if="curIdx==1" v-loading="loading">
        <ul :class="'question_type_tab '+fixedClass">
          <li
            :class="{active : i===questionTypeIdx}"
            v-for="(item, i) in questionTypeList" :key="i"
            @click="questionTypeTabSwitch(i)"><p>{{ item.sectionAlias || item.sectionName}}</p></li>
        </ul>
        <div :id="['page'+key]" class="question_type radio" v-for="(item,key) in questionsDetail" :key="key"
             v-if="exmpData">
          <h2>{{chnNumCharStr(key)}}、{{item.sectionName}}<span>({{item.sectionPrompt}})</span></h2>
          <div class="question_info" v-for="(v,i) in item.questions" :key="i">
            <!--非组合题-->
            <div class="question_false" v-if="v.internalTypeId !== 6">
              <div class="question_info_left">
                <div class="radio_subject" v-if="v.internalTypeId !== 9">
                  <span>{{v.questionNum}}.</span>
                  <div class="text" v-html="v.questionContent"></div>
                </div>
                <div class="radio_subject1" v-if="v.internalTypeId === 9">
                  <span>{{v.questionNum}}.</span>
                  <p v-html="v.questionContent"></p>
                </div>
                <!--单选题-->
                <div class="radio_option" v-if="v.internalTypeId === 1">
                  <el-radio-group v-model="v.questionAnswer">
                    <li v-for="(k,j) in v.items" :key="j">
                      <el-radio :label="k.itemKey" :disabled="v.questionAnswer == k.itemKey? false:true"><span>{{k.itemKey}}：</span>
                        <div class="radio_item" v-html="k.itemValue"></div>
                      </el-radio>
                    </li>
                  </el-radio-group>
                </div>
                <!--多选题-->
                <div class="radio_option" v-if="v.internalTypeId === 2">
                  <el-checkbox-group v-model="v.questionAnswer.split(',')">
                    <li v-for="(k,j) in v.items" :key="j">
                      <el-checkbox :disabled="v.questionAnswer.includes(k.itemKey)? false:true" :label="k.itemKey">
                        <span>{{k.itemKey}}：</span>
                        <p v-html="k.itemValue"></p></el-checkbox>
                    </li>
                  </el-checkbox-group>
                </div>
                <!--单选题-->
                <div class="radio_option" v-if="v.internalTypeId === 3">
                  <li>
                    <el-radio v-model="v.questionAnswer" label="正确" :disabled="v.questionAnswer=='错误'?true:false">{{
                      answerExchange(v.englishOption, '正确') }}
                    </el-radio>
                  </li>
                  <li>
                    <el-radio v-model="v.questionAnswer" label="错误" :disabled="v.questionAnswer=='正确'?true:false">{{
                      answerExchange(v.englishOption, '错误') }}
                    </el-radio>
                  </li>
                </div>
                <div class="right_key"
                     v-if="v.internalTypeId === 1 || v.internalTypeId === 2 || v.internalTypeId === 3">
                  <p>正确答案：{{ answerExchange(v.englishOption, v.questionAnswer) }}</p>
                </div>
                <div class="right_key" v-if="v.internalTypeId === 4">
                  正确答案：<p v-html="v.questionAnswer"></p>
                </div>
                <div class="topic_analysis" v-if="v.flag && v.internalTypeId !== 9" @click="openAnalysis(v)">打开解析<img
                  :src="imgSrcDown"/></div>
                <div class="topic_analysis" v-if="!v.flag && v.internalTypeId !== 9" @click="openAnalysis(v)">收起解析<img
                  :src="imgSrcUp"/></div>
                <span v-if="!v.flag && v.internalTypeId !== 9" class="analysis_cont"
                      v-html="v.questionAnalysis?v.questionAnalysis:'暂无解析'"></span>
                <div class="topic_analysis hands-on" v-if="v.flag && v.internalTypeId == 9" @click="openAnalysis(v)">
                  打开答案<img :src="imgSrcDown"/></div>
                <div class="topic_analysis hands-on" v-if="!v.flag && v.internalTypeId == 9" @click="openAnalysis(v)">
                  收起答案<img :src="imgSrcUp"/>
                </div>
                <div class="commentCont" v-if="!v.flag && v.internalTypeId == 9">
                  <div class="comment1"></div>
                  <div class="comment2">
                    <my-component isShow :optObject="optObject" :refresh="refresh" :myId="v.questionId" :type="type"
                                  :preview="true" :companyCode="companyCode"></my-component>
                  </div>
                  <div class="comment3"></div>
                </div>
              </div>
              <div class="question_info_right">
                <h3>正确率</h3>
                <div class="circular_graph">
                  <ve-ring
                    :data="v.accuracys.chartData"
                    :colors="v.accuracys.colors"
                    :tooltip-visible="false"
                    :settings="v.accuracys.settings"
                    :legend="v.accuracys.legend"
                    width="210px"
                    height="190px"
                    :extend="v.accuracys.chartExtend"
                    :title="v.accuracys.title"
                  ></ve-ring>
                  <ul>
                    <li v-for="(val, i) in v.accuracys.chartData.rows" :key="i">
                      <i :style="'background:'+v.accuracys.colors[i]"></i>
                      <span>{{val.xuanxiang}}</span>
                    </li>
                  </ul>
                </div>
                <div class="question_info_number" v-if="v.internalTypeId === 1">
                  <ul>
                    <li>答对：{{v.accuracys.correctCount}}人</li>
                    <li>答错：{{v.accuracys.errorCount}}人</li>
                  </ul>
                  <ul>
                    <li v-for="(val,i) in v.accuracys.chartData.rows" :key="i">选{{val.xuanxiang}}：{{val.renshu}}人</li>
                  </ul>
                </div>
                <div class="question_info_number otherType" v-if="v.internalTypeId === 2 || v.internalTypeId === 3">
                  <ul>
                    <li>答对：{{v.accuracys.correctCount}}人</li>
                    <li>答错：{{v.accuracys.errorCount}}人</li>
                  </ul>
                </div>
                <div class="question_info_number otherType operation" v-if="v.internalTypeId === 9">
                  <ul>
                    <li v-for="(val, i) in v.accuracys.chartData.rows" :key="i">
                      <span>{{val.xuanxiang}}：{{val.renshu}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--组合题-->
            <div class="zuhe" v-if="v.internalTypeId === 6">
              <div class="question_content">
                <span
                  class="text_index1">阅读以下内容，回答第{{v.questionNum}}-{{v.questionNum + v.childQuestionArr.length -1}}题</span>
                <p class="text" v-html="v.questionContent"></p>
              </div>
              <div class="zuheti" v-for="(a,b) in v.childQuestionArr" :key="b">
                <div class="question_info_left">
                  <div class="radio_subject" v-if="a.internalTypeId !== 9">
                    <span>{{a.questionNum-1}}.</span>
                    <p v-html="a.questionContent"></p>
                  </div>
                  <div class="radio_subject1" v-if="a.internalTypeId === 9">
                    <span>{{a.questionNum-1}}.</span>
                    <p v-html="a.questionContent"></p>
                  </div>
                  <!--单选题-->
                  <div class="radio_option" v-if="a.internalTypeId === 1">
                    <el-radio-group v-model="a.questionAnswer">
                      <li v-for="(k,j) in a.items">
                        <el-radio :label="k.itemKey" :disabled="a.questionAnswer == k.itemKey? false:true"><span>{{k.itemKey}}：</span>
                          <div class="radio_item" v-html="k.itemValue"></div>
                        </el-radio>
                      </li>
                    </el-radio-group>
                  </div>
                  <!--多选题-->
                  <div class="radio_option" v-if="a.internalTypeId === 2">
                    <el-checkbox-group v-model="a.questionAnswer.split(',')">
                      <li v-for="(k,j) in a.items">
                        <el-checkbox :disabled="a.questionAnswer.includes(k.itemKey)? false:true" :label="k.itemKey">
                          <span>{{k.itemKey}}：</span>
                          <p v-html="k.itemValue"></p></el-checkbox>
                      </li>
                    </el-checkbox-group>
                  </div>
                  <!--判断题-->
                  <div class="radio_option" v-if="a.internalTypeId === 3">
                    <li>
                      <el-radio v-model="a.questionAnswer" label="正确" :disabled="a.questionAnswer=='错误'?true:false">{{
                        answerExchange(a.englishOption, '正确') }}
                      </el-radio>
                    </li>
                    <li>
                      <el-radio v-model="a.questionAnswer" label="错误" :disabled="a.questionAnswer=='正确'?true:false">{{
                        answerExchange(a.englishOption, '错误') }}
                      </el-radio>
                    </li>
                  </div>
                  <div class="right_key"
                       v-if="a.internalTypeId === 1 || a.internalTypeId === 2 || a.internalTypeId === 3">
                    <p>正确答案：{{ answerExchange(a.englishOption, a.questionAnswer) }}</p>
                  </div>
                  <div class="right_key" v-if="a.internalTypeId === 4">
                    正确答案：<p v-html="a.questionAnswer"></p>
                  </div>
                  <div class="topic_analysis" v-if="a.flag && a.internalTypeId !== 9" @click="openAnalysis(a)">打开解析<img
                    :src="imgSrcDown"/></div>
                  <div class="topic_analysis" v-if="!a.flag && a.internalTypeId !== 9" @click="openAnalysis(a)">收起解析<img
                    :src="imgSrcUp"/></div>
                  <span v-if="!a.flag && a.internalTypeId !== 9" class="analysis_cont"
                        v-html="a.questionAnalysis?a.questionAnalysis:'暂无解析'"></span>
                  <div class="topic_analysis hands-on" v-if="a.flag && a.internalTypeId == 9" @click="openAnalysis(a)">
                    打开答案<img :src="imgSrcDown"/></div>
                  <div class="topic_analysis hands-on" v-if="!a.flag && a.internalTypeId == 9" @click="openAnalysis(a)">
                    收起答案<img :src="imgSrcUp"/>
                  </div>

                  <div class="commentCont" v-if="!a.flag && a.internalTypeId == 9">
                    <div class="comment1"></div>
                    <div class="comment2">
                      <my-component isShow :optObject="optObject" :refresh="refresh" :myId="a.questionId" :type="type"
                                    :preview="true" :companyCode="companyCode"></my-component>
                    </div>
                    <div class="comment3"></div>
                  </div>
                </div>
                <div class="question_info_right">
                  <h3>正确率</h3>
                  <div class="circular_graph">
                    <ve-ring
                      :data="a.accuracys.chartData"
                      :colors="a.accuracys.colors"
                      :tooltip-visible="false"
                      :settings="a.accuracys.settings"
                      :legend="a.accuracys.legend"
                      width="210px"
                      height="190px"
                      :extend="a.accuracys.chartExtend"
                      :title="a.accuracys.title"
                    ></ve-ring>
                    <ul>
                      <li v-for="(val, i) in a.accuracys.chartData.rows" :key="i">
                        <i :style="'background:'+a.accuracys.colors[i]"></i>
                        <span>{{val.xuanxiang}}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="question_info_number" v-if="a.internalTypeId === 1">
                    <ul>
                      <li>答对：{{a.accuracys.correctCount}}人</li>
                      <li>答错：{{a.accuracys.errorCount}}人</li>
                    </ul>
                    <ul>
                      <li v-for="(val,i) in a.accuracys.chartData.rows" :key="i">选{{val.xuanxiang}}：{{val.renshu}}人</li>
                    </ul>
                  </div>
                  <div class="question_info_number otherType" v-if="a.internalTypeId === 2 || a.internalTypeId === 3">
                    <ul>
                      <li>答对：{{a.accuracys.correctCount}}人</li>
                      <li>答错：{{a.accuracys.errorCount}}人</li>
                    </ul>
                  </div>
                  <div class="question_info_number otherType operation" v-if="a.internalTypeId === 9">
                    <ul>
                      <li v-for="(val, i) in a.accuracys.chartData.rows" :key="i">
                        <span>{{val.xuanxiang}}：{{val.renshu}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="question_exmp" v-if="!exmpData">
          <img src="../../../../../../static/images/wujieguo.png"/>
          <p>学生暂未提交，无法查看</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import myComponent from '../../../../myComponent';
  import * as api from "../../../../../api/testApi";

  export default {
    components: {
      myComponent
    },
    data() {
      return {
        isCheck: false,
        userIdsList: [],

        wrapHeight: window.innerHeight - 90, // 整体页面高度
        curIdx: 0,
        tabList: ['学生完成详情', '试题作答详情'],
        studentName: '',
        questionsDetail: [], //试题作答详情
        ringChartConfig: {
          chartExtend: {
            series: {
              center: ['50%', '50%'],
              label: {
                normal: {
                  show: false,
                  formatter: '{b}: {d}%'
                }
              }
            }
          },
          settings: {
            //hover的时候是否变大
            hoverAnimation: true,
            // 环图 -- 内外径
            radius: ['50px', '70px']
          },
          legend: {
            show: false
          },
          textStyle: {
            color: '#333333',
            fontFamily: '微软雅黑',
            fontSize: 22,
            fontWeight: '600'
          }
        },
        tableData: [],
        fixedClass: '',
        questionTypeIdx: 0,
        questionTypeList: [],
        totalSum: '',
        submitSum: '',
        averScore: '',
        maxScore: '',
        chnNumChar: ["一", "二", "三", "四", "五", "六", "七", "八", "九"],
        loading: true,
        loadingx: true,
        imgSrcDown: '../../../../../../static/images/study/icon/down.png',
        imgSrcUp: '../../../../../../static/images/study/icon/up.png',
        imgSrcRight: '../../../../../../static/images/study/icon/right.png',
        exmpData: true,
        statisticsData: [],
        optObject: {},
        refresh: false,
        iframeUrl: '',
        defaultQuestionNum: 1,
        type: '',
        productFlag: sessionStorage.getItem('productFlag'),
        companyCode: '',
        flag: false,
        template: {},
        subjectId: '',
        paperCode: '',
        queryData: null,
        noDemo: true //仅限demo时使用
      }
    },
    created() {
      this.queryData = this.$route.query
      this.getClassInfo()
      this.getStudentList();
      this.optObject = this.$route.query;
      if (this.productFlag == 3) {
        this.type = 3;
      } else {
        this.type = 2;
      }
      this.setDemoData()
    },
    mounted() {
      this.$refs.detailsWrap.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      setDemoData() {
        if (['2670', '2684'].includes(String(this.$route.query.id))) {
          this.noDemo = false
          this.tabList.pop()
        }
      },
      getClassInfo() {
        let paperId = this.$route.query.paperId
        let classId = this.$route.query.classId
        let courseId = this.$route.query.id
        let examId = this.$route.query.examId
        let param = {
          paperId,
          classId,
          courseId,
          examId
        }
        // 人数、平均、最高
        api.getClassStatisticsDataV2(param).then(rs => {
          if (rs.code == 0) {
            this.totalSum = rs.data.totalSum
            this.submitSum = rs.data.submitSum
            this.averScore = rs.data.averScore
            this.maxScore = rs.data.maxScore
          } else {
            this.$messageError(rs.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      getStudentList(order) {
        let paperId = this.$route.query.paperId
        let classId = this.$route.query.classId
        let obj = {}
        if (order != undefined) {
          obj = {
            paperId: paperId,
            classId: classId,
            courseId: this.$route.query.id,
            nameOrStudentNo: this.studentName,
            schoolId: sessionStorage.getItem('deptId'),
            scoreOrder: order,
            examId: this.queryData.examId
          }
        } else (
          obj = {
            paperId: paperId,
            classId: classId,
            courseId: this.$route.query.id,
            nameOrStudentNo: this.studentName,
            schoolId: sessionStorage.getItem('deptId'),
            examId: this.queryData.examId
          }
        )
        api.getPreviewStudent(obj).then(rs => {
          if (rs.code == 0) {
            this.loadingx = false;
            this.tableData = rs.data;
          } else {
            if (res.msg == 6) {
              this.$router.push({
                path: '/intercept'
              })
            } else {
              this.$messageError(rs.msg)
            }
          }
        }).catch(err => {
          console.log(err)
        })
      },
      getTopic() {
        let classId = this.$route.query.classId;
        let paperId = this.$route.query.paperId;
        let examId = this.$route.query.examId;
        let param = {
          paperId,
          classId,
          examId
        }
        api.getExamAnswerPaperQuestionAccuracyV2(param).then(res => {
          if (res.code == 0) {
            this.loading = false;
            this.exmpData = true;
            this.statisticsData = res.data.accuracyResps;
            this.subjectId = res.data.testPaper.subjectId;
            this.paperCode = res.data.testPaper.paperCode;
            this.questionTypeList = res.data.testPaper.testPaperPartsList[0].testPaperSectionsList;
            let testPaperDatas = res.data.testPaper.testPaperPartsList[0].testPaperSectionsList;
            testPaperDatas.forEach(val => {
              let obj = {};
              obj.sectionName = val.sectionName;
              obj.sectionPrompt = val.sectionPrompt;
              obj.questions = [];
              val.testPaperQuestionsList.forEach(item => {
                let question = {};
                question.internalTypeId = item.questionDto.internalTypeId;
                question.questionContent = item.questionDto.questionContent;
                question.items = item.questionDto.items;
                question.questionAnswer = item.questionDto.questionAnswer;
                question.englishOption = item.questionDto.englishOption;
                question.questionAnalysis = item.questionDto.questionAnalysis;
                question.questionId = item.questionDto.id;
                question.questionCode = item.questionDto.questionCode;
                question.questionNum = this.defaultQuestionNum++;
                question.flag = true;
                question.childQuestionArr = [];
                this.statisticsData.forEach(v => {
                  if (item.questionDto.internalTypeId != 6) {
                    if (item.questionDto.id == v.questionId) {
                      question.accuracys = v;
                      question.accuracys.chartExtend = this.ringChartConfig.chartExtend;
                      question.accuracys.settings = this.ringChartConfig.settings;
                      question.accuracys.legend = this.ringChartConfig.legend;
                      if (v.questionType == 1) {
                        if (question.items.length == 2) {
                          question.accuracys.colors = ["#5397F7", "#FFB23C"];
                          question.accuracys.chartData = {
                            columns: ['xuanxiang', 'renshu'],
                            rows: [
                              {'xuanxiang': 'A', 'renshu': v.acount},
                              {'xuanxiang': 'B', 'renshu': v.bcount}
                            ]
                          }
                        } else if (question.items.length == 3) {
                          question.accuracys.colors = ["#5397F7", "#FFB23C", "#34D3B0"];
                          question.accuracys.chartData = {
                            columns: ['xuanxiang', 'renshu'],
                            rows: [
                              {'xuanxiang': 'A', 'renshu': v.acount},
                              {'xuanxiang': 'B', 'renshu': v.bcount},
                              {'xuanxiang': 'C', 'renshu': v.ccount}
                            ]
                          }
                        } else {
                          question.accuracys.colors = ["#5397F7", "#FFB23C", "#34D3B0", "#FF785A"];
                          question.accuracys.chartData = {
                            columns: ['xuanxiang', 'renshu'],
                            rows: [
                              {'xuanxiang': 'A', 'renshu': v.acount},
                              {'xuanxiang': 'B', 'renshu': v.bcount},
                              {'xuanxiang': 'C', 'renshu': v.ccount},
                              {'xuanxiang': 'D', 'renshu': v.dcount},
                            ]
                          }
                        }
                        question.accuracys.title = {
                          text: (Math.round(v.accuracy * 100) / 100) + '%',
                          subtext: '正确率',
                          x: 'center',
                          y: 'center',
                          itemGap: 5,
                          textStyle: this.ringChartConfig.textStyle,
                          show: true
                        }
                      } else if (v.questionType == 9) {
                        question.accuracys.colors = ["#5397F7", "#FFB23C", "#FF785A"];
                        question.accuracys.title = {
                          text: (Math.round(v.accuracy * 100) / 100) + '%',
                          subtext: '正确率',
                          x: 'center',
                          y: 'center',
                          itemGap: 5,
                          textStyle: this.ringChartConfig.textStyle,
                          show: true
                        },
                          //数据
                          question.accuracys.chartData = {
                            columns: ['xuanxiang', 'renshu'],
                            rows: [
                              {'xuanxiang': '全部答对', 'renshu': v.correctCount},
                              {'xuanxiang': '部分答对', 'renshu': v.correPartialCount},
                              {'xuanxiang': '全部答错', 'renshu': v.errorCount},
                            ]
                          }
                      } else if (v.questionType == 2 || v.questionType == 3) {
                        question.accuracys.colors = ["#5397F7", "#FF785A"];
                        question.accuracys.title = {
                          text: (Math.round(v.accuracy * 100) / 100) + '%',
                          subtext: '正确率',
                          x: 'center',
                          y: 'center',
                          itemGap: 5,
                          textStyle: this.ringChartConfig.textStyle,
                          show: true
                        }
                        question.accuracys.chartData = {
                          columns: ['xuanxiang', 'renshu'],
                          rows: [
                            {'xuanxiang': '正确', 'renshu': v.correctCount},
                            {'xuanxiang': '错误', 'renshu': v.errorCount}
                          ]
                        }
                      }
                    }
                  } else if (item.questionDto.internalTypeId == 6) {
//            		console.log(item.questionDto.childQuestions);
                  }

                });

                //组合题
                if (item.questionDto.internalTypeId == 6) {
                  item.questionDto.childQuestions.forEach(item => {
                    let childQuestionObj = {};
                    childQuestionObj
                    childQuestionObj.internalTypeId = item.internalTypeId;
                    childQuestionObj.questionContent = item.questionContent;
                    childQuestionObj.items = item.items;
                    childQuestionObj.questionAnswer = item.questionAnswer;
                    childQuestionObj.englishOption = item.englishOption;
                    childQuestionObj.questionAnalysis = item.questionAnalysis;
                    childQuestionObj.questionId = item.id;
                    childQuestionObj.questionCode = item.questionCode;
                    childQuestionObj.questionNum = this.defaultQuestionNum++;
                    childQuestionObj.flag = true;
                    this.statisticsData.forEach(v => {
                      if (item.id == v.questionId) {
                        childQuestionObj.accuracys = v;
                        childQuestionObj.accuracys.chartExtend = this.ringChartConfig.chartExtend;
                        childQuestionObj.accuracys.settings = this.ringChartConfig.settings;
                        childQuestionObj.accuracys.legend = this.ringChartConfig.legend;
                        if (v.questionType == 1) {
                          if (childQuestionObj.items.length == 2) {
                            childQuestionObj.accuracys.colors = ["#5397F7", "#FFB23C"];
                            childQuestionObj.accuracys.chartData = {
                              columns: ['xuanxiang', 'renshu'],
                              rows: [
                                {'xuanxiang': 'A', 'renshu': v.acount},
                                {'xuanxiang': 'B', 'renshu': v.bcount}
                              ]
                            }
                          } else if (childQuestionObj.items.length == 3) {
                            childQuestionObj.accuracys.colors = ["#5397F7", "#FFB23C", "#34D3B0"];
                            childQuestionObj.accuracys.chartData = {
                              columns: ['xuanxiang', 'renshu'],
                              rows: [
                                {'xuanxiang': 'A', 'renshu': v.acount},
                                {'xuanxiang': 'B', 'renshu': v.bcount},
                                {'xuanxiang': 'C', 'renshu': v.ccount}
                              ]
                            }
                          } else {
                            childQuestionObj.accuracys.colors = ["#5397F7", "#FFB23C", "#34D3B0", "#FF785A"];
                            childQuestionObj.accuracys.chartData = {
                              columns: ['xuanxiang', 'renshu'],
                              rows: [
                                {'xuanxiang': 'A', 'renshu': v.acount},
                                {'xuanxiang': 'B', 'renshu': v.bcount},
                                {'xuanxiang': 'C', 'renshu': v.ccount},
                                {'xuanxiang': 'D', 'renshu': v.dcount},
                              ]
                            }
                          }
                          childQuestionObj.accuracys.title = {
                            text: (Math.round(v.accuracy * 100) / 100) + '%',
                            subtext: '正确率',
                            x: 'center',
                            y: 'center',
                            itemGap: 5,
                            textStyle: this.ringChartConfig.textStyle,
                            show: true
                          }
                        } else if (v.questionType == 9) {
                          childQuestionObj.accuracys.colors = ["#5397F7", "#FFB23C", "#FF785A"];
                          childQuestionObj.accuracys.title = {
                            text: (Math.round(v.accuracy * 100) / 100) + '%',
                            subtext: '正确率',
                            x: 'center',
                            y: 'center',
                            itemGap: 5,
                            textStyle: this.ringChartConfig.textStyle,
                            show: true
                          },
                            //数据
                            childQuestionObj.accuracys.chartData = {
                              columns: ['xuanxiang', 'renshu'],
                              rows: [
                                {'xuanxiang': '全部答对', 'renshu': v.correctCount},
                                {'xuanxiang': '部分答对', 'renshu': v.correPartialCount},
                                {'xuanxiang': '全部答错', 'renshu': v.errorCount},
                              ]
                            }
                        } else if (v.questionType == 2 || v.questionType == 3) {
                          childQuestionObj.accuracys.colors = ["#5397F7", "#FF785A"];
                          childQuestionObj.accuracys.title = {
                            text: (Math.round(v.accuracy * 100) / 100) + '%',
                            subtext: '正确率',
                            x: 'center',
                            y: 'center',
                            itemGap: 5,
                            textStyle: this.ringChartConfig.textStyle,
                            show: true
                          }
                          childQuestionObj.accuracys.chartData = {
                            columns: ['xuanxiang', 'renshu'],
                            rows: [
                              {'xuanxiang': '正确', 'renshu': v.correctCount},
                              {'xuanxiang': '错误', 'renshu': v.errorCount}
                            ]
                          }
                        }
                      }
                    });
                    question.childQuestionArr.push(childQuestionObj);
                  });
                }
                obj.questions.push(question);
              });
              this.questionsDetail.push(obj);
            });
            console.log(this.questionsDetail);
          } else if (res.code == 1) {
            this.loading = false;
            this.exmpData = false;
          }
        }).catch(error => {
          console.log(error);
        })
      },
      // 打开解析
      openAnalysis(param) {
        this.$set(param, 'flag', !param.flag);
        this.getparams(param.questionId);
      },
      back() {
        this.$router.go(-1)
      },
      searchStudengName(val) {
        this.getStudentList()
      },
      search() {
        this.getStudentList()
      },
      tabSwitch(i) {

        this.curIdx = i;
        this.questionsDetail = [];
        if (this.curIdx == 1) {
          this.loading = true;
          this.getTopic();
        }
      },
      sortthiscolumn(column) {
        if (column.order == 'descending') {
          this.getStudentList(0)
        } else if (column.order == 'ascending') {
          this.getStudentList(1)
        } else {
          this.getStudentList()
        }

      },
      // 导出学生完成详情的数据
      exportList() {

        let paperId = this.$route.query.paperId
        let classId = this.$route.query.classId
        let courseId = this.$route.query.id
        let examId = this.$route.query.examId
        let schoolId = sessionStorage.getItem("deptId");
        let url = process.env.NODE_ENV === 'sx' && window.g && window.g.BASE_API ? window.g.BASE_API : process.env.BASE_API
        window.open(`${url}/api-study/gradeExport/${classId}/${courseId}/${examId}/${paperId}/${schoolId}`);

      },
      // 表格头部样式
      headerCellStyle({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return "background:rgba(83,151,247,0.1);color:#999999;";
        }
      },

      handleSelectionChange(value) {
        this.userIdsList = value.map(item => item.userId)
      },
      // 强制交卷
      submissionPapers(row) {
        let userIds = [row.userId];
        this.batchRecallSubmissionPapers(userIds);
      },
      // 批量交卷
      batchRecallSubmissionPapers(userIds) {
        if (userIds && userIds.length) {
          this.$confirm('此操作将把选中的学生强制交卷', '确认信息', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
            .then(() => {
              let param = {
                examId: this.$route.query.examId,
                classId: this.$route.query.classId,
                userIds: userIds,
              }
              api.teacherSumbitExam(param).then(res => {
                if (res.code === "0") {
                  this.$messageSuccess('交卷成功！')
                  this.getStudentList();
                } else {
                  this.$messageError(res.msg);
                }
              })
            })
        } else {
          this.$messageWarning('请选择要交卷的学生')
        }
      },
      // 撤回某个学生的交卷
      withdrawExam(row) {
        let userIds = [row.userId];
        this.batchRecall(userIds);
      },
      // 批量撤回
      batchRecall(userIds) {

        if (userIds && userIds.length) {
          this.$confirm('此操作将撤回选择学生的交卷状态，变成未交卷并且可以继续做答', '确认信息', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
            .then(() => {
              let param = {
                examId: this.$route.query.examId,
                userIds: userIds
              }
              api.cancelSubmitPaper(param).then(res => {
                if (res.code === "0") {
                  this.$messageSuccess('撤回成功！')
                  this.getStudentList();
                } else {
                  this.$messageError(res.msg);
                }
              })
            })
        } else {
          this.$messageWarning('请选择要撤回交卷的学生')
        }

      },
      seeRow(row) {
        if (row.status == 0) {
          this.$messageWarning('该学生还未提交，无法查看')
          return
        }
        const {href} = this.$router.resolve({
          path: '/switch/test/stupreview',
          query: {
            id: this.$route.query.id,
            classId: this.$route.query.classId,
            userId: row.userId,
            paperId: this.$route.query.paperId,
            name: row.name,
            total: this.$route.query.total,
            className: this.$route.query.className,
            type: this.$route.query.type,
            examId: this.$route.query.examId,
            finishFlag: 1
          }
        });
        window.open(href, '_blank');
      },
      handleScroll() {
        if (this.flag) {
          let scrollTop = this.$refs.detailsWrap.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if (this.$refs.detailsWrap.scrollTop >= 250) {
            this.fixedClass = 'fixedClass'
          } else {
            this.fixedClass = ''
          }
          let top = this.$refs.detailsWrap.scrollTop
          let topicLi = document.querySelectorAll('.question_type')
          topicLi.forEach((item, index) => {
            if (top >= (item.offsetTop - 165)) {
              this.questionTypeIdx = index
            }
          })
        }
      },
      questionTypeTabSwitch(i) {
        this.flag = false;
        let that = this;
        setTimeout(() => {
          that.flag = true
        }, 1000);
        this.questionTypeIdx = i;
        var PageId = document.querySelector('#page' + i);
        // PageId.scrollIntoView();
        // let scrollTop = this.$refs.content.scrollTop
        let wrap = document.querySelectorAll('.details_page_wrap')[0]
        let topicType = document.querySelectorAll('.question_type')
        topicType.forEach((item, index) => {
          if (i == index) {
            wrap.scrollTo(0, item.offsetTop - 156)
          }
        })
      },
      //阿拉伯数字转中文
      chnNumCharStr(index) {
        return this.chnNumChar[index];
      },
      /**
       *
       *根据资源ID 获取动态参数列表
       */
      getparams(questionId) {
        let list = [];
        return new Promise((resolve) => {
          api.getParams(questionId).then(rs => {
            console.log(rs);
            if (rs.code === "0") {
              if (rs.data.length > 0) {
                rs.data.map((item) => {
                  let obj = {
                    key: item.param,
                    value: item.value
                  }
                  list.push(obj);
                  if (item.param == "templateCode") {
                    this.companyCode = item.value;
                  }
                })
                resolve(list);
              }
              resolve(list);
            } else {
              this.$messageError(rs.msg);
            }
          })
            .catch(function (error) {
              this.$messageError("后台接口错误！");
            });
        })
      },
      // 判断题 中英文选项
      answerExchange(english, answer) {
        return english
          ? answer == "正确"
            ? "T"
            : answer == "错误"
              ? "F"
              : ""
          : answer;
      },
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    },
  }
</script>
<style lang="scss" scoped>
  .details_page_wrap {
    margin: 16px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #fff;
    overflow-y: auto;

    .details_page_title {
      line-height: 50px;
      border-bottom: 1px solid #5397F7;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2 {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }

      button {
        width: 72px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(83, 151, 247, 1);
        border-radius: 4px;
        padding: 0;
        font-size: 12px;
        font-weight: 400;
        color: rgba(83, 151, 247, 1);

        &:hover {
          background: rgba(83, 151, 247, 1);
          color: #fff;
        }
      }
    }

    .details_page_top {
      width: 100%;
      height: 120px;
      background: rgba(233, 241, 253, 1);
      border-radius: 4px;

      ul {
        display: flex;
        justify-content: space-around;
        padding: 0 50px;
        margin-top: 12px;

        li {
          width: 300px;
          height: 80px;
          background: rgba(87, 130, 255, 1);
          opacity: 1;
          border-radius: 4px;
          display: flex;
          align-items: center;
          margin-top: 19px;

          img {
            width: 48px;
            height: 48px;
            margin-left: 56px;
            margin-right: 28px;
          }

          div {
            h3 {
              font-size: 24px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
            }

            p {
              font-size: 14px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              margin-top: 12px;
            }
          }

          &:nth-child(1) {
            background: #5782FF
          }

          &:nth-child(2) {
            background: #34D3B0
          }

          &:nth-child(3) {
            background: #FF9E70
          }
        }
      }
    }

    .details_page_bottom {
      .details_page_bottom_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #E6E6E6;
        margin-top: 5px;

        ul {
          display: flex;

          li {
            line-height: 50px;
            margin-right: 40px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            cursor: pointer;
          }

          .active {
            color: #333333;
            font-weight: 600;
            border-bottom: 2px solid #333333;
          }
        }

        .details_page_bottom_search {
          display: flex;
          align-items: center;

          .el-input, .el-select {
            width: 220px;
            margin-right: 10px;

            /deep/ .el-input__inner {
              height: 30px;
              line-height: 30px;
            }

            /deep/ .el-input__icon {
              line-height: 30px;
            }
          }

          .el-button {
            padding: 7px 20px;
            background: #fff;
            border: 1px solid #5397f7;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            color: #5397f7;

            &:hover {
              background: rgba(83, 151, 247, 1);
              color: #fff;
            }
          }
        }
      }

      .student_details_content {
        margin-top: 16px;

        /deep/ .student_details_table {
          border: 1px solid #ebebeb;
          border-radius: 4px;
          box-sizing: border-box;
        }

        /deep/ .el-button--small, .el-button--small.is-round {
          padding: 5px 15px;
          color: #5397f7;
        }

        /deep/ .el-table__empty-text {
          line-height: inherit;

          .empty_data {
            img {
              width: 100px;
            }
          }
        }
      }

      .details_page_content {
        width: 100%;

        .question_type_tab {
          display: flex;
          height: 80px;
          align-items: center;
          background: #fff;

          li {
            padding: 0 15px;
            height: 32px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 16px;
            text-align: center;
            line-height: 32px;
            cursor: pointer;

            p {
              color: #999999;
            }
          }

          .active {
            background: #5397F7;

            p {
              color: #fff;
            }
          }
        }

        .fixedClass {
          position: fixed;
          top: 72px;
          width: 94%;
          z-index: 9;
        }

        .fixedClass + .question_type {
          margin-top: 76px;
        }

        .question_exmp {
          text-align: center;

          img {
            display: inline-block;
            width: 200px;
            height: 200px;
          }
        }

        .question_type {
          h2 {
            font-size: 16px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);

            span {
              font-size: 12px;
              font-weight: 400;
              margin-left: 10px;
            }
          }

          .question_info {
            .question_false {
              display: -webkit-box;
              display: -moz-box;
              margin: 16px 0;
            }

            .zuhe {
              .zuheti {
                display: -webkit-box;
                display: -moz-box;
                margin: 16px 0;
              }

              .question_content {
                margin-top: 10px;
                border: 1px solid #e6e6e6;
                padding: 24px 32px;

                .text_index1 {
                  display: block;
                  font-size: 14px;
                  font-weight: 600;
                  margin-bottom: 10px;
                }

                .text {
                  /deep/ p {
                    line-height: 20px;
                  }
                }
              }
            }

            .question_info_left {
              flex: 1;
              border: 1px solid rgba(230, 230, 230, 1);
              border-right: none;
              padding: 24px 32px;
              box-sizing: border-box;

              .radio_subject, .check_subject, .judge_subject {
                display: flex;
                justify-content: flex-start;

                span {
                  font-size: 14px;
                  color: rgba(51, 51, 51, 1);
                  line-height: 20px;
                }

                .text {
                  display: inline-block;
                  margin-left: 10px;

                  /deep/ p {
                    display: inline-block;
                    line-height: 20px;

                    img {
                      width: 100%;
                    }

                    strong {
                      display: inline-block;
                    }

                    span {
                      img {
                        width: 100%;
                      }
                    }
                  }
                }
              }

              .radio_subject1 {
                display: flex;
                justify-content: flex-start;

                span {
                  font-size: 14px;
                  color: rgba(51, 51, 51, 1);
                  float: left;
                  line-height: 24px;
                }

                p {
                  margin-left: 10px;
                  width: 100%;

                  /deep/ p {
                    line-height: 24px;

                    img {
                      display: block;
                      max-width: 100%;
                    }
                  }
                }
              }

              .radio_option, .judge_option {
                margin-left: 33px;

                /deep/ .el-radio {
                  margin-top: 18px;
                  display: block;

                  .el-radio__input + span.el-radio__label {
                    color: inherit;
                    cursor: pointer;
                  }

                  .el-radio__inner {
                    border: 1px solid #DCDFE6;
                    border-radius: 100%;
                    background-color: #FFF;
                  }

                  .el-radio__input.is-checked .el-radio__inner {
                    border-color: #409EFF;
                    background: #409EFF;

                    &::after {
                      background: #fff;
                    }
                  }

                  .el-radio__label {
                    .radio_item {
                      width: 100%;
                      display: inline-flex;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                      line-height: 22px;
                    }

                    p {
                      display: inline-block;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                      box-sizing: border-box;
                      width: 96%;

                      img {
                        width: 100%;
                      }
                    }
                  }
                }

                /deep/ .el-checkbox {
                  .el-checkbox__input.is-disabled {
                    .el-checkbox__inner {
                      background-color: inherit;
                    }
                  }

                  .el-checkbox__input.is-disabled + span.el-checkbox__label {
                    color: inherit;
                  }
                }

                .el-checkbox-group {
                  margin-top: 10px;

                  /deep/ .el-checkbox__label {
                    line-height: 30px;

                    p {
                      display: inline-flex;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                    }
                  }
                }
              }

              /deep/ .check_option {
                margin-left: 33px;

                .el-checkbox {
                  margin-top: 18px;
                  display: block;

                  .el-checkbox__input + span.el-checkbox__label {
                    color: inherit;
                    cursor: not-allowed;
                  }

                  .el-checkbox__inner {
                    border: 1px solid #DCDFE6;
                    background-color: #FFF;
                  }

                  .el-checkbox__input.is-checked .el-checkbox__inner {
                    border-color: #409EFF;
                    background: #409EFF;

                    &::after {
                      border-width: 1px;
                      border-color: #fff;
                    }
                  }
                }
              }

              .right_key {
                margin: 24px 0 16px 0;

                p {
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(83, 151, 247, 1);
                }
              }

              .topic_analysis {
                font-size: 14px;
                font-weight: 400;
                color: rgba(83, 151, 247, 1);
                cursor: pointer;
                display: inline-block;

                img {
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  margin-left: 4px;
                }
              }

              .intoSystem {
                margin-left: 50px;
              }

              .analysis_cont {
                display: inline-block;
                margin-left: 10px;
              }

              .hands-on {
                margin-top: 12px;
              }

              .commentCont {
                position: relative;

                .comment1 {
                  width: 0px;
                  height: 0px;
                  border: 8px transparent solid;
                  border-bottom-color: #F4F4F4;
                  position: absolute;
                  top: -15px;
                  left: 41px;
                }

                .comment2 {
                  background: #F4F4F4;
                  /*min-height: 105px;*/
                  /*max-height: 396px;*/
                  height: 396px;
                  border-radius: 4px;
                  margin-top: 10px;
                  padding: 16px;
                  overflow: auto;
                }

                .comment3 {
                  width: 0px;
                  height: 0px;
                  border: 9px transparent solid;
                  border-bottom-color: rgba(244, 244, 244, 1);
                  position: absolute;
                  top: -15px;
                  left: 40px;
                }
              }

              .childQuestions_item {
                margin-bottom: 15px;
              }
            }

            .question_info_right {
              width: 424px;
              min-height: 270px;
              border: 1px solid rgba(230, 230, 230, 1);
              position: relative;

              h3 {
                font-size: 14px;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
                margin: 24px 0 0 40px;
              }

              .circular_graph {
                ul {
                  display: flex;
                  margin-left: 40px;

                  li {
                    margin-right: 16px;

                    i {
                      width: 26px;
                      height: 12px;
                      border-radius: 2px;
                      display: inline-block;
                    }

                    span {
                      font-size: 14px;
                      color: rgba(51, 51, 51, 1);
                      margin-left: 2px;
                    }
                  }
                }
              }

              .question_info_number {
                position: absolute;
                right: 15px;
                top: 80px;
              }
            }
          }
        }

        .question_type.radio {
          .question_info_number {
            ul {
              width: 200px;
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              position: relative;

              &:first-child {
                &::after {
                  position: absolute;
                  content: '';
                  width: 86%;
                  height: 1px;
                  background: #E6E6E6;
                  bottom: 0;
                  left: 0;
                }
              }

              li {
                width: 50%;
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                line-height: 30px;
                position: relative;

                &::before {
                  content: "·";
                  color: #5397F7;
                  font-size: 30px;
                  position: absolute;
                  top: -2px;
                  left: -10px;
                }
              }
            }
          }

          .otherType {
            ul {
              display: inherit;

              &:first-child {
                &::after {
                  position: absolute;
                  width: 86%;
                  height: 1px;
                  background: transparent;
                  bottom: 0;
                  left: 0;
                }
              }

              li {
                line-height: 50px;
              }
            }
          }

          .operation {
            ul {
              li {
                line-height: 30px;
              }
            }
          }
        }

        .question_type.check, .judge, .operation {
          .question_info .question_info_right .question_info_number {
            top: 100px;

            ul {
              width: 150px;

              li {
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 30px;
                position: relative;

                &::before {
                  content: "·";
                  color: #5397F7;
                  font-size: 30px;
                  position: absolute;
                  top: -9px;
                  left: -10px;
                }
              }
            }
          }
        }

        .question_type.operation {
          .question_info .question_info_right .question_info_number {
            top: 90px;

            ul {
              width: 170px;

              li {
                margin-bottom: 18px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testing/detailsPage.vue